<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="fillet">
      <div class="retrieval">
        <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
      </div>
    </div>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="pid" slot-scope="params">
        <MySwitch :data="params.params" @onToggle="toggleDisplay"></MySwitch>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="'维保类型配置'" :labelWidth="'110px'" :width="'548px'" :form="mform" :rules="mrules"
      :formCtrl="mformCtrl" :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FixList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "article",
      breadcrumb: [
        { name: "维保管理", path: `/fix/list` },
        { name: "维保类型配置", path: `/fix/config` },
      ],
      cols: [
        { prop: "name", label: "维保类型" },
        { prop: "pid", label: "是否显示", slot: 'pid' },
      ],
      allBtnWidth: '100px',
      btns: [
        {
          ...this.editBtn,
          cb: (data) => {
            this.getItem(data);
            this.showDialog();
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      viewMode: false,
      mform: { name: undefined },
      mrules: {
        name: [
          {
            required: true,
            message: '请填写维保类型',
            trigger: 'blur',
          }
        ],
      },
      mformCtrl: [
        {
          label: "维保类型",
          keyName: "name",
          err: "请填写维保类型",
          type: "text",
        },
      ],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = { ...v }
          obj.open = v.pid + ''
          return obj
        })
      }
      // console.log(this.tableData)
    },
    toggleDisplay({ id }) {
      console.log(id)
      let url = `${this.baseUrl}/updatepid `;
      const params = {
        // userid: this.user.id,
        id,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '修改成功!',
          });
          this.getList(true)
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
          // 禁止隐藏，并刷新
          this.getList()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    addItem() {
      delete this.mform.id;
      this.mform = { name: undefined };
      this.showDialog();
    },
    getItem({ id, name }) {
      this.mform = { ...this.mform, id, name };
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.fillet {
  height: auto;
  margin: 0 auto;
  padding: 20px 0px 10px;
  border-radius: 5px;
  background: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
}

.retrieval {
  height: auto;
  /* overflow: hidden; */
  margin: 0px 20px;
  font-size: 14px;
  color: #606266;

  /deep/ .el-button {
    margin-bottom: 22px;
    padding: 12px 20px;
  }
}
</style>
